module.exports = "Redirecting back to app..."